// Privates local storage
const localStorageGetObject = key => JSON.parse(localStorage.getItem(key));
const localStorageSetItem = (key, value) => localStorage.setItem(key, JSON.stringify(value));
const localStorageRemoveItem = key => localStorage.removeItem(key);
const sessionStorageGetObject = key => JSON.parse(sessionStorage.getItem(key));
const sessionStorageSetItem = (key, value) => sessionStorage.setItem(key, JSON.stringify(value));
const sessionStorageRemoveItem = key => sessionStorage.removeItem(key);
// Local Storage
export const lsGetLoginProfile = () => sessionStorageGetObject('loginProfile');
export const lsSetLoginProfile = value => sessionStorageSetItem('loginProfile', value);
export const lsRemoveLoginProfile = () => {
  sessionStorageRemoveItem('loginProfile');
};

export const lsGetActs = () => localStorageGetObject('acts');
export const lsSetActs = value => localStorageSetItem('acts', value);
export const lsRemoveActs = () => {
  localStorageRemoveItem('acts');
};

export const lsGetAct = () => localStorageGetObject('act');
export const lsSetAct = value => localStorageSetItem('act', value);
export const lsRemoveAct = () => {
  localStorageRemoveItem('act');
};

export const lsGetTransferActs = () => localStorageGetObject('transferActs');
export const lsSetTransferActs = value => localStorageSetItem('transferActs', value);
export const lsRemoveTransferActs = () => {
  localStorageRemoveItem('transferActs');
};

export const lsGetTransferAct = () => localStorageGetObject('transferAct');
export const lsSetTransferAct = value => localStorageSetItem('transferAct', value);
export const lsRemoveTransferAct = () => {
  localStorageRemoveItem('transferAct');
};

export const lsGetGiver = () => localStorageGetObject('giver');
export const lsSetGiver = value => localStorageSetItem('giver', value);
export const lsRemoveGiver = () => {
  localStorageRemoveItem('giver');
};

export const lsGetCifConcession = () => localStorageGetObject('cifConcession');
export const lsSetCifConcession = value => localStorageSetItem('cifConcession', value);
export const lsRemoveCifConcession = () => {
  localStorageRemoveItem('cifConcession');
};

export const lsGetLoginType = () => localStorageGetObject('loginType');
export const lsSetLoginType = value => localStorageSetItem('loginType', value);
export const lsRemoveLoginType = () => {
  localStorageRemoveItem('loginType');
};

export const lsGetSelectedFlow = () => localStorageGetObject('selectedFlow');
export const lsSetSelectedFlow = value => localStorageSetItem('selectedFlow', value);
export const lsRemoveSelectedFlow = () => {
  localStorageRemoveItem('selectedFlow');
};

export const lsGetPermissionFlow = () => localStorageGetObject('permissionFlow');
export const lsSetPermissionFlow = value => localStorageSetItem('permissionFlow', value);
export const lsRemovePermissionFlow = () => {
  localStorageRemoveItem('permissionFlow');
};

// Helpers for store modules
export const paginationData = resp => {
  const objEmpty = {
    total: 0,
    offset: -1,
    limit: -1,
    sort: '',
    direction: 0,
    fields: null,
    Search: null
  };
  return resp.headers['x-pagination'] ? JSON.parse(resp.headers['x-pagination']) : objEmpty;
};

export const lsRemoveDataSignout = () => {
  Object.keys(localStorage).forEach(key => {
    if (key.startsWith('permissionFlow') || key.startsWith('selectedFlow')) {
      localStorageRemoveItem(key);
    }
  });
};

export const lsGetPathToRedirect = () => localStorageGetObject('pathRedirect');
export const lsSetPathToRedirect = value => localStorageSetItem('pathRedirect', value);
export const lsRemovePathToRedirect = () => {
  localStorageRemoveItem('pathRedirect');
};
